/* tslint:disable */
/* eslint-disable */
/**
 * BROStar API
 * Simplify the data management of the BRO
 *
 * The version of the OpenAPI document: v1
 * Contact: servicedesk@nelen-schuurmans.nl
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from "../runtime";
import type { GLDOverview } from "./GLDOverview";
import {
  GLDOverviewFromJSON,
  GLDOverviewFromJSONTyped,
  GLDOverviewToJSON,
  GLDOverviewToJSONTyped,
} from "./GLDOverview";

/**
 *
 * @export
 * @interface ApiGldOverviewList200Response
 */
export interface ApiGldOverviewList200Response {
  /**
   *
   * @type {number}
   * @memberof ApiGldOverviewList200Response
   */
  count: number;
  /**
   *
   * @type {string}
   * @memberof ApiGldOverviewList200Response
   */
  next?: string | null;
  /**
   *
   * @type {string}
   * @memberof ApiGldOverviewList200Response
   */
  previous?: string | null;
  /**
   *
   * @type {Array<GLDOverview>}
   * @memberof ApiGldOverviewList200Response
   */
  results: Array<GLDOverview>;
}

/**
 * Check if a given object implements the ApiGldOverviewList200Response interface.
 */
export function instanceOfApiGldOverviewList200Response(
  value: object
): value is ApiGldOverviewList200Response {
  if (!("count" in value) || value["count"] === undefined) return false;
  if (!("results" in value) || value["results"] === undefined) return false;
  return true;
}

export function ApiGldOverviewList200ResponseFromJSON(json: any): ApiGldOverviewList200Response {
  return ApiGldOverviewList200ResponseFromJSONTyped(json, false);
}

export function ApiGldOverviewList200ResponseFromJSONTyped(
  json: any,
  ignoreDiscriminator: boolean
): ApiGldOverviewList200Response {
  if (json == null) {
    return json;
  }
  return {
    count: json["count"],
    next: json["next"] === undefined ? undefined : json["next"] === null ? null : json["next"],
    previous:
      json["previous"] === undefined
        ? undefined
        : json["previous"] === null
        ? null
        : json["previous"],
    results: (json["results"] as Array<any>).map(GLDOverviewFromJSON),
  };
}

export function ApiGldOverviewList200ResponseToJSON(json: any): ApiGldOverviewList200Response {
  return ApiGldOverviewList200ResponseToJSONTyped(json, false);
}

export function ApiGldOverviewList200ResponseToJSONTyped(
  value?: ApiGldOverviewList200Response | null,
  ignoreDiscriminator: boolean = false
): any {
  if (value == null) {
    return value;
  }

  return {
    count: value["count"],
    next: value["next"],
    previous: value["previous"],
    results: (value["results"] as Array<any>).map(GLDOverviewToJSON),
  };
}
